import React, { Component } from 'react';
import { Button, Card, Col, Form, Icon, Input, Row, Switch, Cascader } from "antd";
import Simple from './Table';


class Store extends Component {
  render() {
    return (
      <Simple />
    );
  }
}


export default Store;



// WEBPACK FOOTER //
// ./src/routes/main/Store/index.js